export const SOFT_CODE = 'img_convert_bing_wuxi'
export const SUB_CODE = 'default'
export const SOFT_CHANNEL = ''
export const SOFT_CODE_360 = 'image_convert_www_qh360' // 360渠道的softcode
/**
 * 软件配置
 */
export const appConfig = {
  name: '轻虾图片转换器',
  logo: '/logo_img.svg',
  contact: {
    customer: 'https://cdn1.ruanqing.com/yinpin/img/ruanqing_qr_code.png', // 客服二维码
    officialAccounts: 'https://cdn1.ruanqing.com/img_geshicn/img/qrcode_for_gzh_ks.png' // 公众号二维码
  },
  footer: {
    copyright: `Copyright © ${new Date().getFullYear()} 昆山软擎网络科技有限公司无锡分公司`,
    recordNumber: '苏ICP备2024152091号',
    beian: '',
    agreement: '/agreement.html',
    privacyPolicy: '/privacy.html'
  },
  companyInfo: {
    name: '昆山软擎网络科技有限公司无锡分公司',
    address: '/map.png',
    about: {
      title: '/ruanqing_logo.png',
      content: [
        {
          title: '关于软擎',
          content: `<p>“软擎”二字灵感来自古希腊神话中擎天神阿特拉斯的意象：他以双肩擎起苍穹，象征支撑、托举与永恒的动力。公司以「以擎之力，重塑生产力」为使命，致力于通过前沿AI技术为全球企业及个人用户提供高效、智能的软件解决方案，推动人工智能技术在各行业的深度应用与普及。</p>`
        }
      ]
    }
  },
  androidDownload: 'https://cdn1.ruanqing.com/img_geshicn/img/Androidapp.png',
  iosDownload: 'https://cdn1.ruanqing.com/img_geshicn/img/iosAPP.png',
  allowDownloadDesktop: true, // 是否允许下载桌面客户端
  allowDownloadAPP: true
}